import React from 'react'

import { ListItem, ListLink } from './Pagination.styles'

export default ({ disabled, isActive, onClick, text }) => (
  <ListItem isActive={isActive} disabled={disabled}>
    <ListLink onClick={onClick}>
      {text}
    </ListLink>
  </ListItem>
)
